module.exports = __webpack_public_path__ + "img/A.a753923d.png";